import { MAX_FILE_SIZE } from "@static/config";
import { toArray } from "lodash";

export function isFileSizeAllowed(file: any) {
  return file?.size < MAX_FILE_SIZE;
}

export function isFileTypeAllowed(file: any) {
  const fileType:string = file.fileName.split(".").pop();
  const approvedTypes = [
    "pdf",
    // "doc",
    // "docx",
    // "ppt",
    // "pptx",
    "jpg",
    "jpeg",
    "png",
  ];

  return approvedTypes.includes(fileType.toLowerCase());
}

export function isFileDuplicated(currentFiles: any, fileToUpload: any) {
  const duplicateFiles = toArray(currentFiles).filter(
    (file) => file.fileName === fileToUpload.fileName
  );

  return duplicateFiles.length > 1;
}
